export enum DocumentContainsPr {
    CONTAINS = "CONTAINS",
    NOT_CONTAINS = "NOT_CONTAINS",
}
